<template>
  <div
    v-show="!item.noType"
    v-tooltip="item.isLegacy ? boxLegacyTooltip : ''"
    v-hover-intent="{
      onEnter: () => handleHoverOnSlideType(item, 'over', typeObj.sectionLabel),
      onExit: () => handleHoverOnSlideType(item, 'out', typeObj.sectionLabel)
    }"
    class="box-type"
    v-click-outside="() => clickOutslideUpgrade(item)"
    :class="{
      beta: item.beta,
      new: item.isNew,
      legacy: item.isLegacy,
      updated: item.isUpdated,
      popular: item.isPopular,
      active: isBoxTypeActive(item),
      'is-eu': item.type === 'openEnded' && isEURegion,
      'hidden': item.hidden,
      'smoke-test': item.isSmokeTest,
      'beta-test': item.isBetaTest,
      'is-disabled': item.disabled,
    }"
  >
    <div
      class="absolute top-3 right-3 icon-free"
      @click="handleSelectSlideType({ item, property: wrapperId })"
    >
      <img
        v-if="isForPairPlan(item)"
        v-tooltip="{
          content:htmlTooltip(item),
          trigger: 'click',
          autoHidden: false,
          show: showSlideTypeTooltip === item.name}"
        class="cursor-pointer pointer-events-none"
        src="@/assets/images/pro.svg"
      />
    </div>
    <div
      class="box-content vertical layout center-justified ml-0.25 relative"
      :class="[item.isLegacy ? 'default': 'pointer' , {'opacity-50': isForPairPlan(item)}]"
      @click="handleSelectSlideType({ item, property: wrapperId })"
    >
      <FeatureUpdateTooltipContent
        v-if="isFeatureUpdateTooltipVisible(item)"
        :title="featureTooltipTitle(item.type)"
        :content="featureTooltipContent(item.type)"
      />
      <SlideTypeIcon
        :slide-type="item.type"
        :child-type="item.slideType"
        :left-side="false"
        :active="isBoxTypeActive(item)"
      />
      <div
        v-if="item.type + item.slideType === loadingItem"
        class="loading-show horizontal layout center center-justified"
      >
        <aha-spinner />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import SlideTypeIcon from '@/components-v2/common/slide-type-icon/SlideTypeIcon.vue'
import FeatureUpdateTooltipContent from '@/components-v2/common/tooltip-feature-update/FeatureUpdateTooltipContent.vue'

import PaymentLocalizationMixin from '@/components-v2/my-plan/user-pricing-v2/PaymentLocalizationMixin'

import imageSubmissionTooltipImage from
  '@/assets/images/feature-update/image-submission-feature-update.svg'
import pollTooltipVideo from '@/assets/images/feature-update/poll.webm'

const mixins = [PaymentLocalizationMixin]

export default {
  components: {
    SlideTypeIcon,
    FeatureUpdateTooltipContent,
  },
  // extends: SlideTypeList,
  mixins,
  props: {
    typeObj: {
      type: Object,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    wrapperId: {
      type: String,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    loadingItem: {
      type: String,
      required: false,
      default: null,
    },
    showSlideTypeTooltip: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      isEURegion: (state) => state.isEURegion,
    }),
  },
  methods: {
    isBoxTypeActive(item) {
      const { type, slideType } = this.slideActive

      return (type === item.type && slideType === item.slideType) ||
          (type === 'multipleChoice' && item.type === 'imageChoice')
    },
    isFeatureUpdateTooltipVisible(slide) {
      if (slide.isUpdated) {
        if (slide.type === 'openEnded' && this.isEURegion) {
          return false
        }

        return true
      }

      return false
    },
    featureTooltipTitle(slideType) {
      if (slideType === 'multipleChoice' || slideType === 'imageChoice') {
        return '<div class="font-bold">👉<span class="pl-1.5">Feature update:</span></div>'
      }
      if (slideType === 'openEnded' && !this.isEURegion) {
        return `
          <div class="font-bold">👉 A new way to answer:</div>
        `
      }

      return ''
    },
    htmlTooltip(item) {
      return `
      <div class='text-base popover-inner  '>
          <div>
          ${this.contentTooltip(item)}
            </div>
        <button class='aha-button mt-5 aha-button-md aha-button-success button-upgrade' >
          ${this.$i18nPresenter.t('Upgrade')}
        </button>
        </div>
        `
    },
    contentTooltip(item) {
      return item.isForPairPlan
        ? this.$i18nPresenter.t('This feature is not available in your current plan.')
        : this.$i18nPresenter.t("You've reached the maximum number of questions for the Free Plan.")
    },
    featureTooltipContent(slideType) {
      if ((slideType === 'multipleChoice' || slideType === 'imageChoice')) {
        return `
          <div class="w-40">
            <p class="pb-1">The slide types ‘Multiple Choice’ and ‘Image Choice’ have been merged into <strong>‘Poll’</strong>. Your content is unchanged.</p>
            <video width="174" height="92" id="poll-video" autoplay>
              <source src='${pollTooltipVideo}' type="video/webm">
              Your browser does not support the video tag.
            </video>
          </div>
        `
      }
      if (slideType === 'openEnded' && !this.isEURegion) {
        return `
         <div class="w-40">
            <p class="pb-1">Participants can now respond with photos.</p>
            <img src='${imageSubmissionTooltipImage}' width="174" height="92" />
          </div>
        `
      }

      return ''
    },
    handleHoverOnSlideType(item, mode, sectionLabel) {
      this.$emit('handleHoverOnSlideType', item, mode, sectionLabel)
    },
    clickOutslideUpgrade(item) {
      this.$emit('clickOutslideUpgrade', item)
    },
    handleSelectSlideType({ item, property }) {
      this.$emit('handleSelectSlideType', { item, property })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variable.scss';
@import '@/assets/scss-v2/variables.scss';

.fas,
.far,
.fab {
  color: $dark-icon-color;
}

.title-table-presentation {
  @apply text-sm font-bold;

  .title-table-presentation-tooltip {
    font-size: 14px;
    color: #b7b7b7;
  }
}

.box-content {
  @apply ring-1 ring-inset ring-secondary-40;
  display: flex;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  padding: 2px 0 0;
  min-height: 72px;
  transition: 0.5s;
  transition-timing-function: cubic-bezier(0.33, 1, 0.68, 1);

  &:hover {
    @apply shadow-lg;
  }
}

.slide-type-section-label {
  padding: 8px 12px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  background-color: rgba(47, 128, 237, 0.15);

  .icon {
    color: #348EF6;
  }
}

.slide-type-section-content {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 10px;
  padding-top: 12px;
  padding-bottom: 24px;
  &.quiz {
    padding-bottom: 16px;
  }
}

.slide-type-section__import {
  display: flex;
  padding-bottom: 1.5rem;
}

.box-type {
  @apply text-secondary-50;
  text-align: center;
  position: relative;
  cursor: pointer;

  &.is-eu.updated {
    .box-content:after {
      display: none;
    }
  }

  &.smoke-test {
    & .box-content {
      &:after {
        display: inline-block;
        position: absolute;
        padding-inline: 0.25rem;
        top: 0.25rem;
        right:0.25rem;
        background-color: #FFF7EA;
        color: #FF922E;
        border-radius: 2px;
        content: 'Soon';
        font-weight: 700;
        font-size: 0.75rem;
      }
    }
  }

  &.beta-test {
    & .box-content {
      &:after {
        display: inline-block;
        position: absolute;
        padding-inline: 0.25rem;
        top: 0.25rem;
        right:0.25rem;
        background-color: #FFF5FA;
        color: #FD5CAD;
        border-radius: 2px;
        content: 'Beta';
        font-weight: 700;
        font-size: 0.75rem;
      }
    }
  }

  &.beta,
  &.new, &.legacy,
  &.popular,
  &.coming-soon,
  &.updated {
    .box-content {
      &:after {
        display: block;
        background: #FFB12E;
        position: absolute;
        top: 2px;
        padding-left: 20px;
        right: -21px;
        width: 90px;
        height: 16px;
        line-height: 18px;
        text-align: center;
        font-size: 8px;
        font-weight: bold;
        color: #fff;
        -webkit-transform: rotate(45deg);
        transform: rotate(45deg);
        content: 'Beta';
        text-transform: uppercase;
      }
    }
  }

  &.new {
    .box-content {
      &:after {
        @apply bg-primary-90;
        content: 'New';
        font-size: 9px;
        line-height: 16px;
        box-shadow: -1.33274px 2.66548px 5.33096px rgba(52, 142, 246, 0.31);
      }
    }
  }

  &.legacy {
    .box-content {
      &:after {
        @apply bg-secondary-50;
        content: 'Legacy';
        font-size: 9px;
        line-height: 16px;
        box-shadow: -1.33274px 2.66548px 5.33096px rgba(180, 188, 207, 0.24);
      }
    }

    &::v-deep .aha-slide-type-icon {
      opacity: 0.5;
    }
  }

  &.popular {
    .box-content {
      &:after {
        background-color: #ffa826;
        content: 'Popular';
        box-shadow: -1px 2px 4px rgba(255, 177, 46, 0.4);
      }
    }
  }

  &.coming-soon {
    .box-content {
      &:after {
        background-color: #eb68a0;
        content: 'Coming';
        box-shadow: -1px 2px 4px rgba(235, 104, 160, 0.24);
      }
    }
  }

  &.updated {
    .box-content {
      &:after {
        @apply bg-green-50;
        content: 'Updated';
        font-size: 7.5px;
        line-height: 16px;
        box-shadow: -1.33274px 2.66548px 5.33096px rgba(51, 193, 115, 0.15);
      }
    }
  }

  .loading-show {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #f3f3f3ba;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &.active {
    .box-content {
      @apply ring-2 ring-primary-90;
    }
  }

  .icon-free{
    position: absolute;
    z-index: 33;
    transform: translate(35%, -48%);
  }

  &.is-disabled {
    .box-content  {
      @apply opacity-50 cursor-not-allowed;
    }
  }
}
</style>
